import{parseScope as e}from"./parse-scope.mjs";const t=(t,n)=>{if(!(!n||!t))return e(t).find(e=>e.type.toLowerCase()===n.toLowerCase())?.id??void 0};export{t as getIdFromScope};
//# sourceMappingURL=get-id-from-scope.mjs.map